interface AnalyticsWindow extends Window {
  gtag?: (...args: unknown[]) => void;
  fbq?: (...args: unknown[]) => void;
}

export async function sendUserEmailToAnalytics(email: string) {
  const normalized = email.trim().toLowerCase();
  const data = new TextEncoder().encode(normalized);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");

  if (typeof window !== "undefined") {
    const w = window as AnalyticsWindow;
    if (w.gtag) {
      w.gtag("config", "G-JYNXZ2K2RS", { user_id: hashHex });
      w.gtag("set", "user_properties", { sha256_email: hashHex });
    }
    if (w.fbq) {
      w.fbq("init", "1189675655400848", { em: hashHex });
      w.fbq("track", "PageView");
    }
  }
}
